import React, { useEffect, useRef } from 'react';

const PaymentWebView = ({ uri, onError, onSucccess }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const messageQueue = [];

    const handleMessage = (event) => {
      try {
        const { data, origin } = event;

        console.log('Received message:', data, 'from origin:', origin);

        const payload = (() => {
          console.log('Received message from origin:', origin);
          try {
            const parsedData = JSON.parse(data);

            return parsedData;
          } catch (jsonError) {
            throw new Error(`❌ Invalid JSON format received: ${data}`);
          }
        })();

        const { error: responseError, result, code } = payload;

        if (responseError) {
          onError?.(result);
        }

        onSucccess?.(result);
      } catch (error) {
        console.error('Error handling message:', error);
      }
    };

    const handleEarlyMessage = (event) => {
      messageQueue.push(event);
    };

    window.addEventListener('message', handleEarlyMessage);

    setTimeout(() => {
      window.removeEventListener('message', handleEarlyMessage);
      window.addEventListener('message', handleMessage);

      messageQueue.forEach((event) => handleMessage(event));
    }, 500);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  if (!uri) {
    return null;
  }

  return (
    <div className="flex flex-1 flex-col relative">
      <div className="flex flex-col sm:m-10 m-0 sm:max-h-[calc(100vh-10rem)] sm:py-8 py-2 sm:px-8 px-4 flex-1 h-fit bg-white rounded-sm">
        <iframe
          src={uri}
          ref={iframeRef}
          className="w-full h-full rounded-sm"
          title="Payment"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          allow="payment *; accelerometer *; gyroscope *; autoplay *; camera *; microphone *; encrypted-media *; fullscreen *; clipboard-write *"
          referrerPolicy="no-referrer-when-downgrade"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default PaymentWebView;
